export const LOGO_MANFRED =
  'https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_color.svg?v=38732000';

export const LOGO_MANFRED_WHITE =
  'https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_blanco.svg?v=38732000';

export const LOGO_MANFRED_MUTED =
  'https://media-asgard.s3.eu-west-1.amazonaws.com/manfred-media/logo_manfred_muted.svg?v=38732000';
